

































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  BlankAnswer, BlankAnswers, ExamReport, ItemAnalysisReport,
} from '@/types/questions.type';
import { TableHeader } from '@/types/general.type';
import BlanksWrongAnswersDialog from './BlanksWrongAnswersDialog.vue';

@Component({
  components: {
    BlanksWrongAnswersDialog,
  },
})
export default class BlanksItemAnalysisTable extends mixins() {
  @Prop(Array) readonly exams!: ExamReport[];

  @Prop(Array) readonly report!: ItemAnalysisReport[];

  @Prop(Number) readonly reportIndex!: number;

  @Prop(Array) readonly headers!: TableHeader[];

  isWrongAnswersShown = false;

  wrongAnswers: string[] | undefined = [];

  showExamDetails(item: ItemAnalysisReport): void {
    if (!this.isWrongAnswersShown) {
      this.$emit('showExamDetails', item);
    }
  }

  getItemAnswers(item: ItemAnalysisReport): BlankAnswer[] {
    return Object.values(item.answers as BlankAnswers);
  }

  getRowSpan(headerIndex: number, itemIndex: number): number {
    switch (headerIndex) {
      case 0:
      case 1:
      case 2:
        return this.report.reduce(
          (rowspan: number, item: ItemAnalysisReport) => rowspan + Object.values(item.answers as BlankAnswers).length, 0,
        );
      case 3:
      case 4:
      case 5:
      case 8:
        return Object.values(this.report[itemIndex].answers as BlankAnswers).length;
      default:
        return 1;
    }
  }

  shouldDisplayColumn(
    headerIndex: number,
    itemIndex: number,
    answerIndex: number,
  ): boolean {
    switch (headerIndex) {
      case 0:
      case 1:
      case 2:
        return itemIndex === 0 && answerIndex === 0;
      case 3:
      case 4:
      case 5:
      case 8:
        return answerIndex === 0;
      default:
        return true;
    }
  }

  getColumnStyle(align: string | undefined, index: number): string {
    let style = `text-align: ${align};`;
    if (index === 0) {
      style += this.labelsDirection() === 'ltr'
        ? 'border-left: 0 !important;'
        : 'border-right: 0 !important;';
    }
    return style;
  }

  getExamTitle(examId: string): string {
    const examReport = this.exams ? this.exams.find((exam) => exam.examId === examId) : {};
    return examReport?.examTitle as string;
  }

  getColumnValue(
    item: ItemAnalysisReport,
    answer: BlankAnswer,
    property: string,
  ): string {
    switch (property) {
      case 'examTitle':
        return this.getExamTitle(item.examId || '');
      case 'modelIndex':
        return `${parseInt(`${item.modelIndex || 0}`, 10) + 1}`;
      case 'blanksIndices':
        return this.formallizeBlanksIndices(item, property);
      case 'difficultyIndex':
        return `${item[property]} % `;
      case 'answer':
        return answer.answer;
      case 'percentage':
        return `${answer.percentage} % `;
      case 'details':
        return '';
      default:
        return item[property];
    }
  }

  showWrongAnswers(wrongAnswers: string[] | undefined): void {
    this.wrongAnswers = wrongAnswers;
    this.isWrongAnswersShown = true;
  }

  isThereWrongAnswers(wrongAnswers: string[] | undefined, headerIndex: number): boolean {
    return Boolean(
      wrongAnswers
      && Array.isArray(wrongAnswers)
      && wrongAnswers.filter((answer) => answer).length
      && headerIndex === this.headers.length - 1,
    );
  }

  closeBlanksWrongAnswersDialog(): void {
    this.isWrongAnswersShown = false;
    this.wrongAnswers = [];
  }

  labelsDirection() {
    return this.$store.state.lang.lang === 'en' ? 'ltr' : 'rtl';
  }

  formallizeBlanksIndices(item: ItemAnalysisReport, property: string): string {
    const blanksIndices = item[property] && Array.isArray(item[property])
      ? item[property] as number[]
      : [];
    return blanksIndices.map(
      (blankIndex) => parseInt(`${blankIndex}`, 10) + 1,
    ).join(', ');
  }
}
